import { createSelector } from '@ngrx/store';
import { selectChartsState } from 'app/main/charts/charts.selectors';
import * as fromCube from 'app/main/cube/cube.selectors';
import * as fromPlan from 'app/main/plan/plan.selectors';
import * as _ from 'lodash';

export const selectUIChartsExpenses = createSelector(
    selectChartsState,
    state => state.expenses || {}
);

export const selectChartsExpensesAna2 = createSelector(
    fromCube.selectCubeForAccount6,
    fromPlan.selectAna2ForAccount6,
    (cube, ana2) => {
        const result = [];
        const timelines = _.groupBy(cube, c => c.timeline);
        _.forEach(timelines, t => {
            const ana2names = _.groupBy(t, e => e.ana2Name);
            const series = [];
            _.forEach(ana2, a => {
                series.push({
                    name: a.name,
                    value: _.sumBy(ana2names[a.name], 'flux')
                });
            });
            result.push({
                name: t[0].timeline,
                series
            });
        });
        return result;
    }
);

export const selectChartsExpensesAna3 = createSelector(
    fromCube.selectCubeForAccount6,
    selectUIChartsExpenses,
    (cube, expenses) => {
        const result = [];
        if (expenses && expenses.ana2) {
            const selection = cube.filter(c =>
                c.timeline === expenses.ana2.timeline && c.ana2Name === expenses.ana2.ana2Name);
            const ana3 = _.groupBy(selection, 'ana3Name');
            _.forEach(ana3, a => {
                const name = a[0].ana3Name;
                result.push({
                    name,
                    value: Math.abs(_.sumBy(a, 'flux'))
                });
            });
        }
        return result;
    }
);

export const selectChartsExpensesDetail = createSelector(
    fromCube.selectCubeForAccount6,
    selectUIChartsExpenses,
    (cube, expenses) => {
        const result = [];
        if (expenses && expenses.ana2) {
            const selection = cube.filter(c =>
                c.timeline === expenses.ana2.timeline && c.ana3Name === expenses.ana3.ana3Name);
            const providers = _.groupBy(selection, 'providerLabel');
            _.forEach(providers, p => {
                const name = p[0].providerLabel;
                result.push({
                    name,
                    value: _.sumBy(p, 'flux')
                });
            });
        }
        return _.take(_.orderBy(result, ['value', 'name'], ['asc', 'asc']), 12);
    }
);
